import { useFlags } from "launchdarkly-react-client-sdk";

/**
 * Gates the whole feature in the app. Callers must also force the session
 * value off when this is false, or a session that already has it on keeps
 * sending it after the flag is turned back off.
 */
export function useCreativeBoostEnabled(): boolean {
  const { enableAdStudioCreativeBoost } = useFlags();
  return Boolean(enableAdStudioCreativeBoost);
}
